// extracted by mini-css-extract-plugin
var _1 = "AgreementStyle-module__agreement___xJdqP";
var _2 = "AgreementStyle-module__checkbox___X55zb";
var _3 = "AgreementStyle-module__document-preview-btn___r9edN";
var _4 = "AgreementStyle-module__document-preview-btn___r9edN";
var _5 = "AgreementStyle-module__search-icon___w8WHt";
var _6 = "AgreementStyle-module__search-icon___w8WHt";
var _7 = "AgreementStyle-module__section-text___lKqzx";
var _8 = "AgreementStyle-module__section-text___lKqzx";
var _9 = "AgreementStyle-module__text___qKtey";
var _a = "AgreementStyle-module__title___m84hb";
export { _1 as "agreement", _2 as "checkbox", _3 as "document-preview-btn", _4 as "documentPreviewBtn", _5 as "search-icon", _6 as "searchIcon", _7 as "section-text", _8 as "sectionText", _9 as "text", _a as "title" }
